<template>
  <div lang="tr" class="vertical-align-step-0">
    <form method="POST" id="step0" @submit.prevent="sendForm" class="mb-4">
      <h3 class="main_question text-center font-weight-normal mt-4 font-weight-bold">
        {{ $t('Almak istediğiniz hizmeti seçin') }}
      </h3>

      <div v-if="taxPackage && taxPackage.id">
        <div
          @click="isSelectedTaxPackage = !isSelectedTaxPackage"
          class="box-border2 selectable-field"
          v-bind:class="{ selected: isSelectedTaxPackage }"
        >
          <div class="box-content-field">
            <div>
              <div class="new-product-top-field">
                <div class="new-product-top-field-inside">
                  <div class="check-field" />
                  <span class="new-product-name">{{ getProductName(taxPackage) }}</span>
                </div>
                <div class="new-badge-field">{{ $t('Yeni Paket') }}</div>
              </div>
            </div>
            <span class="new-product-description">{{ getProductDescription(taxPackage) }}</span>

            <div class="">
              <ul class="vertical-center features-spacing main-feature mt-4 features-half">
                <li v-for="feature in taxPackageFeatures" :key="feature.text" class="col-12">
                  <span class="d-flex align-items-start feature-item">
                    <span class="feature-text">{{ feature.text }}</span>
                    <i
                      v-if="feature.tooltipOptions"
                      v-tippy="feature.tooltipOptions.text"
                      class="fa fa-info-circle feature-icon"
                    ></i>
                  </span>
                </li>
              </ul>
            </div>

            <hr />

            <div class="new-product-bottom-field">
              <div class="bottom-left-field">
                <div class="old-price-field overline">
                  <span class="old-price">{{ formatPrice(898, taxPackage.currency) }} </span>
                  <span class="fee-text">
                    {{
                      taxPackage.type === 'subscription'
                        ? taxPackage.period === 'annual'
                          ? ' /' + $t('Yıl')
                          : ' /' + $t('Ay')
                        : ''
                    }}</span
                  >
                </div>
                <div class="new-price-field">
                  <span class="new-price">{{ formatPrice(taxPackage.net_price, taxPackage.currency) }} </span>
                  <span class="fee-text"
                    >{{
                      taxPackage.type === 'subscription'
                        ? taxPackage.period === 'annual'
                          ? ' /' + $t('Yıl')
                          : ' /' + $t('Ay')
                        : ''
                    }}
                  </span>
                </div>
              </div>

              <div class="bottom-right-field">
                <div class="price-badge-field">
                  <img src="/img/icons/lightning.svg" alt="price-badge" />
                  <span class="ml-1">{{ $t('daha tasarruflu', { price: '%28' }) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="addressPackage && addressPackage.id">
        <div
          @click="isSelectedAddressPackage = !isSelectedAddressPackage"
          class="box-border2 selectable-field"
          v-bind:class="{ selected: isSelectedAddressPackage }"
        >
          <div class="box-content-field">
            <div>
              <div class="new-product-top-field">
                <div class="check-field" />
                <div class="new-product-top-field-inside">
                  <span class="new-product-name">{{ getProductName(addressPackage) }}</span>
                </div>
                <div class="new-badge-field">{{ $t('Yeni Paket') }}</div>
              </div>
            </div>
            <span class="new-product-description">{{ getProductDescription(addressPackage) }}</span>

            <div class="">
              <ul class="vertical-center features-spacing main-feature mt-4 features-half">
                <li v-for="feature in addressPackageFeatures" :key="feature.text" class="col-12">
                  <span class="d-flex align-items-start feature-item">
                    <span class="feature-text">{{ feature.text }}</span>
                    <i
                      v-if="feature.tooltipOptions"
                      v-tippy="feature.tooltipOptions.text"
                      class="fa fa-info-circle feature-icon"
                    ></i>
                  </span>
                </li>
              </ul>
            </div>

            <hr />

            <div class="new-product-bottom-field">
              <div class="bottom-left-field">
                <div class="old-price-field overline">
                  <span class="old-price">{{ formatPrice(238, addressPackage.currency) }} </span>
                  <span class="fee-text">
                    {{
                      addressPackage.type === 'subscription'
                        ? addressPackage.period === 'annual'
                          ? ' /' + $t('Yıl')
                          : ' /' + $t('Ay')
                        : ''
                    }}</span
                  >
                </div>
                <div class="new-price-field">
                  <span class="new-price">{{ formatPrice(addressPackage.net_price, addressPackage.currency) }} </span>
                  <span class="fee-text"
                    >{{
                      addressPackage.type === 'subscription'
                        ? addressPackage.period === 'annual'
                          ? ' /' + $t('Yıl')
                          : ' /' + $t('Ay')
                        : ''
                    }}
                  </span>
                </div>
              </div>

              <div class="bottom-right-field">
                <div class="price-badge-field">
                  <img src="/img/icons/lightning.svg" alt="price-badge" />
                  <span class="ml-1">{{ $t('daha tasarruflu', { price: '%28' }) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectedCompany.has_title">
        <h3 class="main_question mt-4">{{ $t('Şirket İsmi') }}</h3>
        <div class="row">
          <div class="col-12">
            <InputField
              v-model="title"
              name="company_title"
              :placeholder="$t('Şirket İsmi')"
              v-validate="'required|min:3'"
              v-tippy="$t('Şirketinizin ismini giriniz')"
              :error="errors.first('company_title')"
              :validateFields="fields['company_title']"
            />
          </div>
        </div>
        <h3 class="main_question">{{ $t('Faaliyet Alanı') }}</h3>
        <div class="row">
          <div class="form-group col-12 mb-0">
            <div class="clearfix">
              <v-select
                :placeholder="this.$t('Faaliyet Alanı Seçimi')"
                :options="activityAreaOptions"
                index="value"
                label="label"
                v-model="selected_activity_areas_mock"
                :clearable="false"
                class="wide"
                :class="{ 'is-invalid': errors.first('global_activity_area') }"
                v-validate="selected_activity_areas.length <= 0 ? 'required' : ''"
                name="global_activity_area"
                :disabled="selected_activity_areas.length >= 3"
                @change="addToSelectedActivityAreas"
              >
              </v-select>
              <span v-show="errors.first('global_activity_area')" class="show-invalid invalid-feedback">{{
                errors.first('global_activity_area')
              }}</span>
              <error-box field="global_activity_area" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="selected-activity-items">
              <div class="selected-activities" v-for="(area, index) in selected_activity_areas" :key="area">
                <span>{{ getAreaValueInLocalLang(area) }}</span>
                <button class="btn bg-white shadow-none" @click="removeSelectedArea(index)">
                  <i class="fas fa-times fa-xs" style="color: #cb444a"></i>
                </button>
              </div>
            </div>
          </div>
          <div v-if="selected_activity_areas.length >= 3" class="col-12">
            <div class="d-flex align-items-center text-dark activity-area-warning">
              <i class="fa fa-info-circle alert-icon-size fa-info-circle" style="color: #f2c253"></i>
              {{ $t('Faaliyet Alanı Seçimi Uyarı Metni') }}
            </div>
          </div>
        </div>
      </div>
    </form>
    <addressChangeConfirmationModal
      :main-package="addressChangeProduct"
      ref="ukAddressChangeConfirmationModal"
      @confirm-address-package="confirmAddressChangeProduct"
    />
    <ukTaxConfirmationModal
      :features="ukTaxConfirmFeatures"
      @confirm="taxConfirmationConfirm"
      @cancel="taxConfirmationCancel"
      ref="ukTaxConfirmationModal"
    />
  </div>
</template>
<script>
import RegisterStore from '../../../stores/register';
import CompanyStore from '../../../stores/company';
import ProductStore from '@/stores/product';
import TokenStore from '@/stores/token';
import InputField from './../../InputField.vue';
import globalActivityAreasHelper from '../../../assets/helpers/globalActivityAreasHelper';
import addressChangeConfirmationModal from '../../modals/addressChangeConfirmation.vue';
import ukTaxConfirmationModal from '../../modals/ukTaxConfirmation.vue';

export default {
  components: {
    InputField,
    addressChangeConfirmationModal,
    ukTaxConfirmationModal,
  },
  data() {
    return {
      selectedCompany: {},
      products: [],
      selectedMainCompanyType: null,
      selectedProducts: [],
      title: '',
      company: {
        global_activity_area: null,
      },
      isSelectedTaxPackage: false,
      isSelectedAddressPackage: false,
      productsCodes: ['UK_TAX_PACKAGE_PRODUCT', 'UK_ADDRESS_PACKAGE_PRODUCT', 'UK_ADDRESS_CHANGE'],
      addressChangeProduct: {},
      taxPackageFeatures: this.$t('Uk Tax Maddeleri'),
      addressPackageFeatures: this.$t('Uk Address Maddeleri'),
      activityAreaOptions: this.$t('globalActivityAreaOptions'),
      selected_activity_areas: [],
      selected_activity_areas_mock: null,
      taxPackage: {},
      addressPackage: {},
      callback: null,
      ukTaxConfirmFeatures: this.$t('Uk Tax Confirmation Maddeleri Transfer'),
    };
  },
  created() {
    this.fillPage();
  },
  methods: {
    taxConfirmationConfirm() {
      this.isSelectedTaxPackage = true;
      if (this.isSelectedAddressPackage) {
        const element = this.$refs.ukAddressChangeConfirmationModal.$el;
        $(element).modal('show');
      } else {
        this.sendForm(this.callback);
      }
    },
    taxConfirmationCancel() {
      if (this.isSelectedAddressPackage) {
        const element = this.$refs.ukAddressChangeConfirmationModal.$el;
        $(element).modal('show');
      } else {
        this.sendForm(this.callback);
      }
    },
    openSummaryModal(callback) {
      if (callback) {
        this.callback = callback;
      }

      if (!this.isSelectedTaxPackage) {
        const element = this.$refs.ukTaxConfirmationModal.$el;
        $(element).modal('show');
      } else {
        if (this.isSelectedAddressPackage) {
          const element = this.$refs.ukAddressChangeConfirmationModal.$el;
          $(element).modal('show');
        } else {
          this.sendForm(this.callback);
        }
      }
    },
    confirmAddressChangeProduct() {
      this.sendForm();
    },
    async fillPage() {
      this.startWaiting();
      if (this.$route.query.companyId === 'newuser') {
        this.startWaiting();
        await RegisterStore.dispatch('createCompany', {
          company_nation_id: 3,
        }).then((s) => {
          const token = s.data.token;
          TokenStore.commit('setOnlyAccessToken', token);
          const query = Object.assign({}, this.$route.query);
          delete query.companyId;
          this.$router.replace({ path: this.$route.path, query: query });
        });
      }

      this.startWaiting();
      CompanyStore.dispatch('getCompany').then((s) => {
        if (s.data.data.length) {
          this.company = s.data.data[0];
          this.$store.commit('setCompany', s.data.data[0]);
          if (this.company.company_nation_id !== 3 || this.company.company_type_id !== 12) {
            this.company.package = [];
            this.changeNationToUk();
          } else {
            this.getProducts();
          }

          this.title = this.selectedCompany.has_title ? this.company.name : this.company.users.data[0].fullname;

          if (this.company.global_activity_area) {
            this.selected_activity_areas = this.company.global_activity_area.split(',');
            for (let i = 0; i < this.selected_activity_areas.length; i++) {
              const area = this.selected_activity_areas[i];
              const translatedArea = this.getActivityAreaInEnglish(area);

              if (translatedArea !== null) {
                this.selected_activity_areas[i] = translatedArea;
              } else {
                this.selected_activity_areas.splice(i, 1);
                i--;
              }
            }
          }
        }
      });
    },
    changeNationToUk() {
      const data = {
        company_type_id: 12,
        company_type_code: 'UKLIMITED',
        register_type: 'transfer',
      };
      RegisterStore.dispatch('step1', data).then((s) => {
        this.getProducts();
      });
    },
    getProducts() {
      ProductStore.dispatch('getProductsByCodes', {
        codes: this.productsCodes,
        companyTypeId: 12,
        companyId: this.company.id,
      }).then((s) => {
        this.products = s.data.data;
        this.selectedCompany = this.products[0].prices.data[0].companyType.data;
        this.endWaiting();

        if (this.company.package) {
          if (this.company.package.includes('UK_TAX_PACKAGE_PRODUCT')) {
            this.isSelectedTaxPackage = true;
          }

          if (this.company.package.includes('UK_ADDRESS_PACKAGE_PRODUCT')) {
            this.isSelectedAddressPackage = true;
          }

          const addressChangeProduct = this.products.find((x) => x.code.includes('UK_ADDRESS_CHANGE'));
          if (addressChangeProduct) {
            this.addressChangeProduct = addressChangeProduct;
          }
        }

        const taxPackage = this.products.find((element) => element.code === 'UK_TAX_PACKAGE_PRODUCT');

        if (taxPackage) {
          this.taxPackage = taxPackage;
        }

        const addressPackage = this.products.find((element) => element.code === 'UK_ADDRESS_PACKAGE_PRODUCT');

        if (addressPackage) {
          this.addressPackage = addressPackage;
        }
      });
    },
    getAreaValueInLocalLang(area) {
      const matchingOption = this.activityAreaOptions.find((option) => option.value === area);
      return matchingOption.label;
    },
    getActivityAreaInEnglish(area) {
      if (area && globalActivityAreasHelper[area]) {
        return globalActivityAreasHelper[area];
      }
      return null;
    },
    addToSelectedActivityAreas(e) {
      if (!this.selected_activity_areas.some((item) => item === e) && e) {
        this.selected_activity_areas.push(e);
      }
      this.selected_activity_areas_mock = null;
    },
    removeSelectedArea(index) {
      this.selected_activity_areas.splice(index, 1);
    },
    async sendForm() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.startWaiting();

          let data = {
            company_type_id: this.selectedCompany.id,
            company_type_code: this.selectedCompany.code,
            name: this.selectedCompany.has_title
              ? this.title
              : this.company.users
              ? this.company.users.data[0].fullname
              : undefined,
            register_type: 'transfer',
          };

          this.company.global_activity_area = this.selected_activity_areas.join(',');
          if (this.company.global_activity_area != null) {
            data = { ...data, ...{ global_activity_area: this.company.global_activity_area } };
          }

          const packageData = [];
          if (this.isSelectedAddressPackage) {
            packageData.push(this.addressPackage.code);
            if (this.addressChangeProduct && this.addressChangeProduct.code) {
              packageData.push(this.addressChangeProduct.code);
            }
          }

          if (this.isSelectedTaxPackage) {
            packageData.push(this.taxPackage.code);
          }

          RegisterStore.dispatch('step1', data).then((s) => {
            if (s.data.success === false) {
              this.$toasted.error(this.$t('AlertMessages.Lütfen bir ürün seçin'));
              this.endWaiting();
              return;
            }
            RegisterStore.dispatch('package', {
              packages: packageData,
            }).then((s) => {
              this.$store.commit('setCompanyId', s.data.data.id);
              this.callback();
            });
          });
        }
      });
    },
  },
};
</script>
<style>
.selected-activity-items {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
}
.selected-activities {
  display: flex;
  align-items: center;
  border: 1px solid #dee2e6;
  padding: 10px 8px !important;
  gap: 10px;
  align-self: stretch !important;
}

.selected-activities .btn {
  padding: 0 !important;
}

.activity-area-warning {
  margin-top: 10px;
  color: black;
}

.activity-area-warning .fa-info-circle {
  margin-right: 8px;
}
</style>
